<template>
  <v-container fluid>
    <SimplePageHeader>
    </SimplePageHeader>
    <HelloWorld />
  </v-container>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import HelloWorld from '@/components/HelloWorld'

export default {
  components: {
    SimplePageHeader,
    HelloWorld
  }
}
</script>
